<template>
  <div class="bodys">
    <div class="contentBox">
      <div class="searchBox">
        <input
          v-model="vinNo"
          type="text"
          class="ipt"
          placeholder="请输入车牌/车架号"
        >
        <div>
          <button :disabled="loading" class="btn" :class="loading ? 'disabled1' : ''" @click="add">
            <img v-show="loading" class="loading" src="../assets/loading.gif" alt="">
            查询车辆位置
          </button>
        </div>
        <div class="tips1">注：输入下单时提供给业务员的车牌/车架号</div>
        <div class="tips2">如有疑问，请联系你的专属客服</div>
      </div>
      <div v-if="!isFirst">
        <img src="../assets/yanshi.gif" class="img" alt="">
      </div>
      <div v-show="details.length === 0 && isFirst" class="noData flex-d al-center noText">
        <img src="../assets/noText.png" alt="">
        <div>{{ errMsg }}</div>
      </div>
      <div v-if="details.length > 0">
        <div v-for="(detail, detailIndex) in displayDetails" :key="detail.id || detail.vinNo || detailIndex">
          <div class="searchBox m-t1" v-if="detail.vinNo">
            <div>{{ detail.vinNo }} {{ detail.brand }} {{ detail.model }}</div>
            <div class="info">起运地：{{ detail.startAddress }}</div>
            <div class="info">目的地：{{ detail.endAddress }}</div>
            <div class="info">发运状态：{{ detail.transStatus?.label }}</div>
          </div>
          <div class="searchBox m-t1" v-if="detail.gpsDetails && detail.gpsDetails.length > 0">
            <div class="steps">
              <div v-for="(item, index) in detail.gpsDetails" :key="item.id || index">
                <div class="step-item">
                  <span class="step-dot" :class="index === 0 ? 'active' : ''"></span>
                  <div class="step-content">
                    <div class="step-title">{{ item.location }}</div>
                    <div class="step-desc">{{ item.recordTime }}</div>
                  </div>
                  <div
                    v-if="index !== detail.gpsDetails.length - 1"
                    class="step-line"
                    :class="index === 0 ? 'active' : ''"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import axios from 'axios'

const vinNo = ref('')
const details = ref([])
const isFirst = ref(false)
const errMsg = ref('')
const loading = ref(false)
const displayDetails = computed(() => [...details.value].reverse())

const add = () => {
  if (!vinNo.value) {
    errMsg.value = '请输入车牌/车架号'
    details.value = []
    return
  }

  loading.value = true
  axios.get(`https://prod.56pai.cn/api/trans/app/order/vehicle/huayu/${vinNo.value}`).then(res => {
    if (res.data.code !== 10000) {
      errMsg.value = res.data.msg
      details.value = []
      return
    }

    if (Array.isArray(res.data.data)) {
      details.value = res.data.data
      errMsg.value = ''
      if (res.data.data.length === 0) {
        errMsg.value = '未查询到数据'
      }
    } else {
      errMsg.value = res.data.msg
      details.value = []
    }
  }).finally(() => {
    loading.value = false
    isFirst.value = true
  })
}
</script>

<style scoped lang="less">
.bodys {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: #fafafa;
}

.title {
  height: 55px;
  width: 100%;
  background: #fff;
  font-size: 17px;
}

.contentBox {
  padding: 10px;
}

.searchBox {
  border-radius: 4px;
  background: #fff;
  padding: 15px 10px;
}

.ipt {
  width: 97%;
  height: 40px;
  padding-left: 3%;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border: 1px solid #3470ff;
}

.btn {
  width: 100%;
  height: 40px;
  border: none;
  margin-top: 15px;
  background: #3470ff;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tips1 {
  font-size: 12px;
  color: rgba(212, 48, 48, 1);
  margin-top: 15px;
}

.tips2 {
  font-size: 12px;
  color: rgba(131, 135, 154, 1);
  margin-top: 10px;
}

.info {
  font-size: 14px;
  color: rgba(86, 89, 112, 1);
  margin-top: 5px;
}

.orderNo {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #3470ff;
}

.step-item {
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(237, 237, 237, 1);
  margin-right: 10px;
  flex-shrink: 0;
  align-self: flex-start;
}

.step-content {
  display: flex;
  flex-direction: column;
  margin-top: -5px;
}

.step-title {
  font-size: 14px;
}

.step-desc {
  font-size: 12px;
  color: #999;
}

.step-line {
  position: absolute;
  top: 10px;
  left: 5px;
  bottom: -20px;
  width: 2px;
  background-color: rgba(237, 237, 237, 1);
}

.active {
  background: rgba(52, 112, 255, 1);
}

.img {
  width: 100%;
  height: 100%;
}

.noText {
  margin-top: 20px;
  color: rgba(131, 135, 154, 1);
  font-size: 14px;
}

.loading {
  width: 20px;
  width: 20px;
  margin-right: 4px;
}

.disabled1 {
  background: rgba(52, 112, 255, 0.7);
}
</style>
